import { LabClient } from 'models/client-directory';
import { InvoiceDelivery } from 'models/invoice';
import { Order } from 'models/order';
import { Organization } from 'models/organization';
import { CONSTANTS } from 'config/constants';
import { customerSettings } from './customerSettings';

export type ClinicInvoiceSettingsResult = {
    clinicType: string;
    clinicDelivery: string;
    childHasFullInvoiceConfig: boolean;
    activeClientSettings: LabClient;
};

export const resolveClinicInvoiceSettings = (
    order: Order,
    parentClientSettings: LabClient,
    childClientSettings: LabClient,
    currentOrg: Organization,
): ClinicInvoiceSettingsResult => {
    const customerIsParent = order?.customer._id === order?.deliveryDetails.destination._id;
    const isChildWithOwnSettings = !customerIsParent && childClientSettings.useOwnInvoiceSettings;

    const clinicSettingsSource = isChildWithOwnSettings
        ? order?.deliveryDetails?.destination?.customerSettings || []
        : order?.customer?.customerSettings || [];

    let clinicType: string =
        customerSettings.getCustomerSetting(clinicSettingsSource, CONSTANTS.SETTINGS_NAMES.INVOICING_TYPE) || '';
    let clinicDelivery: string =
        customerSettings.getCustomerSetting(clinicSettingsSource, CONSTANTS.SETTINGS_NAMES.INVOICING_DELIVERY) || '';

    const labOverrideClinicForcedSetting = customerSettings.getCustomerSetting(
        currentOrg.customerSettings || [],
        CONSTANTS.SETTINGS_NAMES.ALLOW_LAB_INVOICE_OVERRIDE,
    );

    if (labOverrideClinicForcedSetting && clinicDelivery !== InvoiceDelivery.SCHEDULED_ELECTRONIC) {
        clinicType = '';
        clinicDelivery = '';
    }

    const childHasFullInvoiceConfig = !!(
        isChildWithOwnSettings &&
        childClientSettings.invoiceEnabled &&
        childClientSettings?.invoiceSettings?.type &&
        childClientSettings?.invoiceSettings?.invoiceDelivery
    );

    const activeClientSettings = childHasFullInvoiceConfig ? childClientSettings : parentClientSettings;

    return { clinicType, clinicDelivery, childHasFullInvoiceConfig, activeClientSettings };
};
